import { Entity } from "@app/entity/model/entity";
import * as EntitySelectors from "@app/entity/store/selectors/entity.selectors";
import { LoadingState } from "@app/root-store/api-result.state";
import * as RouterSelectors from "@app/root-store/selectors/root-store.selectors";
import { ClareDbCollection } from "@app/shared/resources/resource-objectifier";
import { User } from "@app/user/model/user";
import { UserManagementSelectors } from "@app/user/store";
import { UserManagementState, initialUserManagementState } from "@app/user/store/user-management.state";
import { createFeatureSelector, createSelector } from "@ngrx/store";

export const selectState = createFeatureSelector<UserManagementState>("user-management");

type CustomerListItem = User & {
    owner: string;
};

export const getCustomerList = createSelector(
    EntitySelectors.selectEntities,
    UserManagementSelectors.getAllCustomers,
    (entities: ClareDbCollection<Entity>, users: User[]) => {
        const userData: CustomerListItem[] = [];
        users.forEach(user => {
            let owner = null;
            if (entities) {
                owner = (entities[user.entityId] || { name: "" }).name;
            }

            const data = { ...user, owner, createdSignin: user.gitkitId ? "Yes" : "" };

            userData.push(data);
        });
        return userData;
    }
);

export const getMobileCustomerList = createSelector(
    EntitySelectors.selectEntities,
    UserManagementSelectors.getAllCustomers,
    (entities: ClareDbCollection<Entity>, users: User[]) => {
        const customers: any[] = [];
        users.forEach(user => {
            const data = Object.assign(user, {
                owner: (entities[user.entityId] || { name: "" }).name,
            });
            customers.push({
                id: user.id,
                name: `${user.firstName || ""} ${user.lastName || ""}`,
                email: user.email,
                owner: data.owner,
            });
        });

        return customers;
    }
);

export const getCurrentCustomer = createSelector(
    selectState,
    RouterSelectors.findIdParam,
    (state: UserManagementState, userId) => state?.customers?.result?.[userId] || undefined
);

export const getCustomerState = createSelector(
    selectState,
    (state: UserManagementState = initialUserManagementState) => state.customers?.callState || LoadingState.init
);
export const getCustomerCallState = createSelector(selectState, (state: UserManagementState) => state.customers.callState);
